import { useMutation, useQuery, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { MATERIAL_CACHE_PATH } from '../../../../constants/globalConstants'
import { switchFavouriteRequest } from '../../../../utils/sharedApi'
import {
  MaterialPreviewType,
  MaterialsResponseType,
} from '../../../../utils/types'
import { getPurchasedMaterials } from './GalleryModule-api'

export const useFetchPurchasedMaterials = (
  page: number = 1,
  category: string | undefined,
  filterDate: string | null,
  sortOrder: string | undefined,
  filterAuthor: string | null
) => {
  const query = useQuery(
    [
      MATERIAL_CACHE_PATH,
      {
        type: 'purchased',
      },
      {
        page,
        category,
        filterDate,
        sortOrder,
        filterAuthor,
      },
    ],
    async () =>
      await getPurchasedMaterials(
        page,
        category,
        filterDate,
        sortOrder,
        filterAuthor
      ),
    {
      // keepPreviousData: false,
      // staleTime: 600000,
      // refetchInterval: 600000,
      keepPreviousData: false,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: 'always',
    }
  )
  return query
}

export const useFavouriteItem = (queryKey: any[]) => {
  const client = useQueryClient()
  const mutation = useMutation((id: number) => switchFavouriteRequest(id), {
    onMutate: async (id) => {
      const oldMaterialsInfo: MaterialsResponseType | undefined =
        await client.getQueryData(queryKey)

      if (oldMaterialsInfo === undefined) {
        return
      }

      const updatedMaterials = {
        items: oldMaterialsInfo.items.map((item: MaterialPreviewType) => {
          if (item.id === id) {
            return {
              ...item,
              isFavorite: !item.isFavorite,
            }
          } else {
            return item
          }
        }),
        total: oldMaterialsInfo.total,
        page: oldMaterialsInfo.page,
        size: oldMaterialsInfo.size,
      }
      client.setQueryData(queryKey, updatedMaterials)
      return { oldMaterialsInfo }
    },
    onError: (err, newTodo, context: any) => {
      client.setQueryData(queryKey, context.oldMaterialsInfo)
      toast.error('Не удалось добавить в избранное')
    },
    onSettled: async () => {
      // await client.invalidateQueries(MATERIAL_CACHE_PATH)
    },
  })
  return mutation
}
